import React from 'react';
import { useSelector } from 'react-redux';
import { ReactComponent as Saplogo } from 'src/Images/icons/common/sap.svg';

function TableContent({ headers }) {
  const productReducer = useSelector((state) => state.productReducer);
  const { products } = productReducer.products;
  const paddingMode = localStorage.getItem('paddingMode') || 'comfy';

  return (
    <tbody>
      {products && products.length > 0 ? (
        products.map((productsObj) => (
          <tr key={productsObj.product_code}>
            {headers.map((header) => (
              <td
                className={`table-data ${paddingMode === 'compact' ? `compact-padding` : `comfortable-padding`}`}
                key={header.value}
              >
                <div
                  className={`div-flex-row ${header.value === 'stage' ? 'cg-5 div-align-center' : ''}`}
                >
                  {header.value === 'sap_code' ? (
                    productsObj[header.value] ? (
                      <div className="flex items-center">
                        <Saplogo className="sap-icon icon-size-md" />
                        <span>{productsObj[header.value]}</span>
                      </div>
                    ) : (
                      <span>{productsObj[header.value]}</span>
                    )
                  ) : header.value === 'name' ? (
                    <span>{productsObj[header.value]}</span>
                  ) : header.value === 'leadproduct' ? (
                    <span>{productsObj[header.value]}</span>
                  ) : (
                    <span>{productsObj[header.value]}</span>
                  )}
                </div>
              </td>
            ))}
          </tr>
        ))
      ) : (
        <div className="no-data-found border-bottom">
          <span className="text-sm">No Product Created</span>
        </div>
      )}
    </tbody>
  );
}

export default TableContent;
